import React, {useContext, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import get from 'lodash/get';
import classnames from 'classnames';
import {PulseLoader} from 'halogenium';
import SmartPaymentButtons, {PayPalSDKWrapper} from 'react-smart-payment-buttons';
import {payPalSDKClientID} from '../../../configs/constants';
import {createPayPalOrder, capturePayPalTransaction} from '../../../utils/coins';
import {Modal, ThemeContext} from '../index';
import CoinsIcon from '../../../assets/coins_small.jpg';

export default function ConsPackModal({
  isModalOpened, onModalClose, paymentPacks = [], updateUserCoins,
}) {
  const {primaryColor} = useContext(ThemeContext);
  const [curerntPackIndex, selectPack] = useState(0);
  const [isPaymentSuccessful, setPaymentState] = useState(false);
  useEffect(() => {
    if (paymentPacks.length) {
      paymentPacks[0].selected = true;
    }
  }, []);
  const onSelectPack = (index) => {
    paymentPacks.forEach((p) => {p.selected = false;});
    paymentPacks[index].selected = true;
    selectPack(index);
  };

  const renderItem = (item, index) => {
    const key = uniqueId('paymentPack_');
    const {price, silverCoins} = item;
    const isCurrent = index === curerntPackIndex;
    const packClasses = classnames('coin-packs_row', {
      'coin-packs_row__selected': isCurrent,
    });

    return (
      <ThemeContext.Consumer key={key}>
        {(theme) => {
          const bgColor = theme.primaryColor;

          return (
            <div
              className={packClasses}
              onClick={() => {
                onSelectPack(index);
              }}
              style={{
                borderColor: isCurrent ? bgColor : '',
              }}
            >
              <div className="coin-packs__coins">
                <img src={CoinsIcon} alt="Coins" width={30}/>
              </div>
              <div>{`Pack with ${silverCoins} YakSilver`}</div>
              <div><span className="coin-packs__price">{`$${price}`}</span></div>
            </div>
          );
        }}
      </ThemeContext.Consumer>
    );
  };

  const createOrder = async () => {
    setPaymentState(false);

    const [currentPack] = paymentPacks.filter(p => p.selected);

    const order = await createPayPalOrder(currentPack.id);
    const {id: orderId} = order;

    return orderId;
  };

  const onApprove = async (data, actions) => {
    const {orderID: orderId, payerID: payerId} = data;
    const captureData = await actions.order.capture();
    const captureId = get(captureData, 'purchase_units[0].payments.captures[0].id');
    const {payer: {email_address: payerEmail}} = captureData;

    setPaymentState(true);

    const {totalTokens: silverCoins} = await capturePayPalTransaction({
      captureId,
      orderId,
      payerId,
      payerEmail,
    });

    if (silverCoins) {
      updateUserCoins(silverCoins);
    }
  };

  const onError = () => setPaymentState(false);

  return (
    <Modal
      title="Buy YakSilver"
      isOpen={isModalOpened}
      onClose={onModalClose}
      customClasses="modal_coins-packs"
    >
      <div className="row row_space-between">
        <div className="col-12">
          <div className="coin-packs">
            {isPaymentSuccessful && (
              <div className="alert alert-success">Your Payment was Successful!</div>
            )}
            {paymentPacks.map(renderItem)}
          </div>
        </div>
      </div>
      <div className="row row_center">
        <PayPalSDKWrapper
          clientId={payPalSDKClientID}
          loading={<PulseLoader color={primaryColor} size="16px" margin="4px"/>}
        >
          <SmartPaymentButtons
            createOrder={createOrder}
            onApprove={onApprove}
            onError={onError}
          />
        </PayPalSDKWrapper>
      </div>
    </Modal>
  );
}

ConsPackModal.propTypes = {
  isModalOpened: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  updateUserCoins: PropTypes.func.isRequired,
  paymentPacks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
